const KEYCODES = {
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  B: 'b',
  A: 'a',
  START: 'Enter',
};

export class KonamiCode {
  constructor() {
    this.correctSequence = [
      KEYCODES.UP,
      KEYCODES.UP,
      KEYCODES.DOWN,
      KEYCODES.DOWN,
      KEYCODES.LEFT,
      KEYCODES.RIGHT,
      KEYCODES.LEFT,
      KEYCODES.RIGHT,
      KEYCODES.B,
      KEYCODES.A,
      KEYCODES.START,
    ];
    this.codeActive = false;
    this.currentIndex = -1;
  }

  get nextAction() {
    return this.correctSequence[this.currentIndex + 1];
  }

  get isFinalAction() {
    return this.currentIndex === (this.correctSequence.length - 2);
  }

  activateListeners(store) {
    document.addEventListener('keydown', event => this.processEvent(event, store));
  }

  startSequence() {
    this.codeActive = true;
    this.currentIndex = 0;
  }

  continueSequence() {
    this.currentIndex += 1;
  }

  terminateSequence() {
    this.codeActive = false;
    this.currentIndex = -1;
  }

  processEvent(event, store) {
    if (event.key === this.nextAction) {
      if (this.isFinalAction) {
        window.scrollTo({ top: 0 });
        store.commit('ui/setShowBlueScreen', true);
        this.terminateSequence();
      } else {
        this.continueSequence();
      }
    } else {
      this.terminateSequence();
    }
  }

}
